// import "./Events.scss";

const Events = () => {
  return (
    <div className="Events_page">
      
    </div>
  );
};

export default Events;

